import { useRouteError } from 'react-router-dom';
import WarningCircleBlue from '@/assets/Images/warningCircleBlue.svg';
import '@/pages/unAuthorized/UnAuthorizedScreen.scss';
import { isChunkLoadError } from './lazyWithRetry';

/**
 * Router-level error boundary. React Router catches errors thrown while rendering
 * a route (including a lazy import that ultimately rejects) and renders this instead
 * of its default "Unexpected Application Error!" stack trace. Chunk-load failures get
 * a "new version available" message with a reload; everything else falls back to the
 * generic error message.
 */
export default function RouteErrorBoundary() {
  const isChunkError = isChunkLoadError(useRouteError());

  return (
    <div className="container-fluid">
      <div className="warning-notes">
        <img src={WarningCircleBlue} alt="" aria-hidden="true" />
        <h6>{isChunkError ? 'A new version of Maverick is available.' : 'Something went wrong.'}</h6>
        {isChunkError && (
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Reload
          </button>
        )}
      </div>
    </div>
  );
}
